// extracted by mini-css-extract-plugin
export default {"JobDetails__tag":"EditLabel_JobDetails__tag__xfVdf","tag":"EditLabel_tag__ScAt5"};